import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Quiz from "./Quiz";

const RegisterForm = ({ setLoggedIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [InvalidAttempt, setInvalidAttempt] = useState(false);
  const [TooShort, setTooShort] = useState(false)
  const [InputChecker, setInputChecker] = useState(false);
  const [MissingInputs, setMissingInputs] = useState([]);
  const [MissingMessage, setMissingMessage] = useState("");
  // You can assign the user extra attributes for when they register an account.
  // As you can see on swagger, attributes is optional where its an object and you
  // can store extra attributes like profile picture, favorite color, etc.
  // to fill out when the user creates an account.
  const [attributes, setAttributes] = useState({
    username: '',
    picture: '/OIP.jpg',
    description: '',
    followerCount: 0,
    followingCount: 0,
    blockedPosts: {}
  });

  const getInputs = () => {
    // console.log("LOOPER")
    // console.log(MissingInputs);
    let full = 'Missing Inputs: '
    setMissingMessage('')
    for (let entry of MissingInputs) {
      full += entry + ", "
    }
    setMissingMessage(full.substring(0,full.length - 2))
    // console.log(MissingMessage)
    return;
  }

  const navigate = useNavigate();
  const checkFields = () => {
    // console.log("BP1");
    // console.log(attributes);
    MissingInputs.pop();
    MissingInputs.pop();
    MissingInputs.pop();

    // console.log(MissingInputs);

    email.length == 0 && MissingInputs.push("Email");
    password.length == 0 && MissingInputs.push("Password");
    // console.log("BP1-2")
    attributes.username.length == 0 && MissingInputs.push("Username");

    // console.log(MissingInputs);
    // console.log("BP1-1")
    if (MissingInputs.length > 0) {
      setInputChecker(true);
      // console.log(MissingInputs);
      // console.log("false, done.")
      return false;
    }
    // console.log("true, done");
    return true;
  };

  const clearStates = () => {
    setInvalidAttempt(false);
    setTooShort(false);
    setInputChecker(false);
  }

  const submitHandler = (event) => {
    // event.preventDefault() prevents the browser from performing its default action
    // In this instance, it will prevent the page from reloading
    // keeps the form from actually submitting as well
    event.preventDefault();
    //Check if any previous states were modified.
    clearStates();
    // console.log("CHECKING BLANKS");
    let blanks = checkFields();
    // console.log(blanks);
    if (!blanks) {
      // console.log("blank fields caught");
      // console.log(MissingInputs);
      getInputs();
      return;
    }

    if(password.length < 8) {
      // console.log("BP3");
      setTooShort(true);
      // console.log("BAD!");
      // console.log(TooShort);
      return;
    }

    if (!(TooShort)) {
      const blockedPosts = {}
      // console.log("Valid Everything! Checking Email!")
      fetch(process.env.REACT_APP_API_PATH + "/auth/signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          attributes,
          blockedPosts : blockedPosts
        })
        ,
      })
        .then((res) => res.json())
        .then((result) => {
          // Successfully registered an account
          // console.log(result);
          // set the auth token and user ID in the session state
          sessionStorage.setItem("token", result.token);
          sessionStorage.setItem("user", result.userID);
          // call setLoggedIn hook from App.jsx to save the login state throughout the app
          setLoggedIn(true);
          // Reload the window for when the user logs in to show the posts
          navigate("/quiz");
          window.location.reload();
        })
        .catch((err) => {
          // console.log(err);
          setInvalidAttempt(true);
          setTooShort(false);
        });
    };
    }

  useEffect(() => {
    // If the user is logged in, make sure they cannot see the login form
    if (sessionStorage.getItem("token")) {
      navigate("/");
    }
  }, []);

  return (
    <>
    <img className='formLogo' src="newLogo.png" alt="Logo" style={{width:"250px", height: "250px"}} />
      <div className="form-bubble">
        <div className="top-bubble">
        <h2 className="title-card">Create an account!</h2>

        {/* <h1>Register</h1> */}
        <form onSubmit={submitHandler}>
        <label>
            {/* Username */}
          <span className="form-label-span">Username</span>
            <input
              className="form-entry"
              type="username"
              autoComplete="off"
              // placeholder="Username:"
              onChange={(event) => setAttributes({
                  ...attributes,
                  username: event.target.value
              })}
            />
          </label>
          <br />
          <br />
          <label>
            {/* Email */}
          <span className="form-label-span">Email</span>
            <input
              className="form-entry"
              type="email"
              autoComplete="off"
              // placeholder="Email:"
              // event.target refers to the DOM that is triggered from an event, such as onChange, onClick, etc.
              // event.target.value holds the value that is passed in to the input field from the onChange
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>
          <br />
          <br />
          <label>
            {/* Password */}
          <span className="form-label-span">Password</span>
            <input
              className="form-entry"
              type="password"
              autoComplete="off"

              // placeholder="Password:"
              onChange={
                (event) => setPassword(event.target.value)}
            />
          </label>
          <br />
          <br />
          {InvalidAttempt && <h6 id='errorMsg' style={{color: "red", fontSize: "14px"}}>Email Already Used!</h6>}
          {TooShort && <h6 id='errorMsg' style={{color: "red", fontSize: "14px"}}>Password Must Be 8 Characters or Greater</h6>}
          {InputChecker && <h6 id='errorMsg' style={{color: "red", fontSize: "14px"}}>{MissingMessage}</h6>}
          <input type="submit" className="submitbutton" id="form-submit" value="Register" />
        </form>
        </div>

        {/* REGISTRATION BUBBLE BORDER */}

        <div className="bottom-bubble">
        <h2 className="title-card" style={{marginBottom:"-15px", fontSize:"20px"}}>Already Signed Up?</h2>
        <div>
        <p>
          <div className="form-entry" id="register-bubble">
          <Link to="/" id="uncolored-link">Login</Link>
          </div>
        </p>
      </div>
    </div>
    
      {/* <div>
        <p>
          Reset your password <Link to="/reset-password">here</Link>
        </p>
      </div> */}

        </div>
    </>
  );
};

export default RegisterForm;
